import { FloatingFormItem } from '@/components/_common';
import { useGenerateTerm } from '@/core/domain/reports/terms/GenerateTerm.hook';
import {
  FontJustification,
  FontJustificationTranslation,
  FontSize,
  FontSizeTranslation,
  FontSpacing,
  FontSpacingTranslation,
  generateTermsWorkorderInterface,
  TermsTypes,
} from '@/core/domain/reports/terms/GenerateTerm.types';
import { useReportGenerate } from '@/hooks';
import { FileType } from '@/hooks/useFileLoading';

import { Col, Form, Modal, ModalProps, Row, Select } from 'antd';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  termType?: TermsTypes;
  format?: FileType;
  complementId?: number;
}

export default function WarrantyModal({
  onCancel,
  open,
  termType,
  format = 'PDF',
  complementId,
}: Props) {
  const [form] = Form.useForm<generateTermsWorkorderInterface>();
  const formValues = Form.useWatch([], form);

  const generateTerm = useGenerateTerm();

  const report = useReportGenerate();

  const fontJustificationOptions = [
    {
      label: FontJustificationTranslation[FontJustification.LEFT],
      value: FontJustification.LEFT,
    },
    {
      label: FontJustificationTranslation[FontJustification.RIGHT],
      value: FontJustification.RIGHT,
    },
    {
      label: FontJustificationTranslation[FontJustification.CENTER],
      value: FontJustification.CENTER,
    },
    {
      label: FontJustificationTranslation[FontJustification.JUSTIFY],
      value: FontJustification.JUSTIFY,
    },
  ];

  const fontSizeOptions = [
    {
      label: FontSizeTranslation[FontSize.SMALL],
      value: FontSize.SMALL,
    },
    {
      label: FontSizeTranslation[FontSize.MEDIUM],
      value: FontSize.MEDIUM,
    },
    {
      label: FontSizeTranslation[FontSize.LARGE],
      value: FontSize.LARGE,
    },
  ];

  const fontSpacingOptions = [
    {
      label: FontSpacingTranslation[FontSpacing.SMALL],
      value: FontSpacing.SMALL,
    },
    {
      label: FontSpacingTranslation[FontSpacing.MEDIUM],
      value: FontSpacing.MEDIUM,
    },
    {
      label: FontSpacingTranslation[FontSpacing.LARGE],
      value: FontSpacing.LARGE,
    },
  ];

  const handleCancel = async () => {
    form.resetFields();
    onCancel();
  };

  const handleGenerateReport = async () => {
    if (complementId && termType) {
      const obj: generateTermsWorkorderInterface = {
        ...formValues,
        term: termType,
        complementId,
      };

      const result = await generateTerm.mutateAsync(obj);

      if (format === 'PDF') {
        report.downloadFile({
          result,
          fileName: 'termo_de_garantia.pdf',
        });
      } else {
        report.openFile({
          result,
          fileName: 'termo_de_garantia.pdf',
          fileType: 'application/pdf',
        });
      }

      handleCancel();
    }
  };

  return (
    <Modal
      title="Termo de garantia"
      okText="Gerar relatório"
      confirmLoading={generateTerm.isLoading}
      onOk={handleGenerateReport}
      open={open}
      onCancel={handleCancel}
      destroyOnClose
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem
              name="fontJustification"
              label="Orientação do texto"
            >
              <Select options={fontJustificationOptions} allowClear />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem name="fontSize" label="Tamanho da fonte">
              <Select options={fontSizeOptions} allowClear />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem name="fontSpacing" label="Tamanho do espaçamento">
              <Select options={fontSpacingOptions} allowClear />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
